import axios from "axios";
import { getToken, getTokenHeader } from "../../../../Common/Token";
import { paginateDPUrl, createDispatchPlanOrderUrl, orderDetailsUrl } from "../urls";

// DP Actions
export const getpaginateDPAction = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(paginateDPUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};
export const getOrderDetailsAction = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(orderDetailsUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};
export const createDispatchPlanAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken(); 
    await axios
      .post(
        `${createDispatchPlanOrderUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      }) 
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};
